module.exports = __webpack_public_path__ + "img/fenix.c48d046f.png";